<template>
  <div class="d-flex align-items-center">
    <!-- <img
      width="40"
      height="40"
      :src="userDetail?.photo || $getInitials(userDetail?.name)"
      style="border-radius: 50%"
      class="mr-2"
    /> -->
    <div style="line-height: 1.2;">
      <p class="mb-0">
        {{ userDetail?.name }}
      </p>
      <small class="mb-0">{{ userDetail?.position ?? '-' }} </small>
    </div>
  </div>
</template>
<script>
export default {
  name: 'UserTemplate',
  props: {
    userDetail: null,
  },
}
</script>
